<template>
  <div>
    <div class="page-title">
      {{ $t('data.payout_transaction') }}
    </div>
    <div class="page-container">

      <PayoutTransDetails />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Data_Payout',
  components: {
    PayoutTransDetails: () => import('./components/PayoutTransDetails.vue')
  }
}
</script>

<style scoped>
.page-container{

}
.page-container .page-title {
  padding-bottom: 24px;
  border-bottom: 1px solid #D3D7DF;
}
</style>
